import React, { lazy, Suspense } from "react";
import {BrowserRouter as Router} from "react-router-dom";
import {LocalizationProvider} from "@material-ui/pickers";
import LocalizedRouter from "./component/app/routing/LocalizedRouter";
import {contentful} from "./common/apollo";
import {keycloak} from "./common/keycloak";
import {ReactKeycloakProvider} from "@react-keycloak/web";
import DateFnsUtils from "@material-ui/pickers/adapter/date-fns";
import enGBLocale from "date-fns/locale/en-GB";
import {ApolloProvider} from "@apollo/client";
import {DEV_ENV, LOCAL} from "./common/constant";
import {getBrowser} from "./common/common";
import {ErrorBoundary} from "react-error-boundary";
import {CookiesProvider} from "react-cookie";
import {useLogger} from "./hooks/useLogger";
import LocalizedProvider from "./store/providers/LocalizedProvider";
import LocaleProvider from "./store/providers/LocaleProvider";
import CurrencyProvider from "./store/providers/CurrencyProvider";
import ResortsProvider from "./store/providers/ResortsProvider";
import {ContentfulProvider} from "react-contentful";
import {contentfulClient} from "../app/common/contentful/client";
import UserProvider from "./store/providers/UserProvider";
import MarketplaceConsentProvider from "./store/providers/MarketplaceConsentProvider";
import GlobalLoader from "./component/widget/skeleton/GlobalLoader";
import {MarketPlaceShareInfoProvider} from "./store/providers/MarketplaceShareInfoProvider";

const Layout = lazy(() => import("./component/layout/Layout"));

function App() {
    const isSafari = getBrowser() === "Safari";
    const {logger} = useLogger();

    const errorHandler = (error) => {
        logger(error?.message, "error", "ReactErrorBoundary", error?.stack);
    };

    return (
        <ReactKeycloakProvider
            authClient={keycloak}
            initOptions={{
                onLoad: "check-sso",
                silentCheckSsoRedirectUri: window.location.origin + "/silent-check-sso.html",
                checkLoginIframe: !isSafari,
                pkceMethod: "S256",
                enableLogging: location.host.includes(DEV_ENV) || location.host.includes(LOCAL)
            }}
        >
            <ApolloProvider client={contentful}>
                <ContentfulProvider client={contentfulClient}>
                    <LocalizedRouter RouterComponent={Router}>
                        <LocalizationProvider
                            dateAdapter={DateFnsUtils}
                            locale={enGBLocale}
                        >
                            <ErrorBoundary onError={errorHandler}>
                                <CookiesProvider>
                                    <UserProvider>
                                        <LocalizedProvider>
                                            <LocaleProvider>
                                                <CurrencyProvider>
                                                    <ResortsProvider>
                                                        <MarketplaceConsentProvider>
                                                            <MarketPlaceShareInfoProvider>
                                                                <Suspense fallback={<GlobalLoader />}>
                                                                    <Layout />
                                                                </Suspense>
                                                            </MarketPlaceShareInfoProvider>
                                                        </MarketplaceConsentProvider>
                                                    </ResortsProvider>
                                                </CurrencyProvider>
                                            </LocaleProvider>
                                        </LocalizedProvider>
                                    </UserProvider>
                                </CookiesProvider>
                            </ErrorBoundary>
                        </LocalizationProvider>
                    </LocalizedRouter>
                </ContentfulProvider>
            </ApolloProvider>
        </ReactKeycloakProvider>
    );
}

export default App;
